export default __webpack_public_path__ + "static/media/products-icon-hover.d83bad21.svg";